export default () => {
  return {
    title: props => ({
      ...props.muiTheme.typography.caption,
      padding: props.muiTheme.spacing(0.5, 1, 0, 1),
      color: props.muiTheme.palette.tooltip.color
    }),
    tooltipContainer: props => ({
      display: 'flex',
      alignItems: 'center',
      padding: props.muiTheme.spacing(0.5, 1, 0.5),
      height: props.muiTheme.spacing(3)
    }),
    labelContainer: props => ({
      padding: 0,
      margin: 0,
      color: props.muiTheme.palette.tooltip.color
    }),
    label: props => ({
      ...props.muiTheme.typography.caption
    }),
    value: props => ({
      ...props.muiTheme.typography.caption,
      marginLeft: 5,
      fontWeight: props.muiTheme.typography.fontWeightBold
    }),
    icon: {
      marginRight: 10,
      padding: 0
    }
  };
};
